import { useRef } from "react";
import { Camera, Images, X } from "lucide-react";
import { compressImage, fmtBytes } from "../lib/media";
import { toast } from "sonner";
import { useState } from "react";
import { Loader2 } from "lucide-react";

export const PhotoPicker = ({ photos, onChange, disabled }) => {
  const [busy, setBusy] = useState(false);
  const input = useRef(null);
  const gallery = useRef(null);

  const pick = async (e) => {
    const files = Array.from(e.target.files || []);
    setBusy(true);
    const out = [];
    for (const f of files) {
      try { const r = await compressImage(f); if (r.warn) toast.warning(`${f.name || "Photo"} is still ${fmtBytes(r.after)} after compression`); out.push({ blob: r.blob, url: URL.createObjectURL(r.blob), before: r.before, after: r.after }); }
      catch (e) { toast.error(e.code === "not_image" ? `Skipped ${f.name || "file"} — not an image` : `Couldn't process ${f.name || "that photo"} (unsupported format, e.g. HEIC on this browser)`); }
    }
    setBusy(false);
    onChange([...photos, ...out]);
    e.target.value = "";
  };

  const remove = (i) => { URL.revokeObjectURL(photos[i].url); onChange(photos.filter((_, j) => j !== i)); };

  return (
    <div data-testid="photo-picker">
      <input ref={input} type="file" accept="image/*" capture="environment" hidden onChange={pick} data-testid="photo-input" />
      <input ref={gallery} type="file" accept="image/*" multiple hidden onChange={pick} data-testid="photo-gallery-input" />
      <div className="flex gap-2 flex-wrap items-center">
        {photos.map((p, i) => (
          <div key={p.url} className="thumb" data-testid={`photo-thumb-${i}`}>
            <img src={p.url} alt="" />
            {p.before != null && <span className="thumb-size notranslate" translate="no" data-testid={`photo-size-${i}`}>{fmtBytes(p.before)} → {fmtBytes(p.after)}</span>}
            <button type="button" className="thumb-x" onClick={() => remove(i)} data-testid={`photo-remove-${i}`} aria-label="Remove"><X size={12} /></button>
          </div>
        ))}
        {busy && <div className="thumb thumb-add" data-testid="photo-compressing"><Loader2 size={20} className="animate-spin text-primary" /><span className="text-[10px]">Compressing…</span></div>}
        <button type="button" data-testid="photo-add-button" className="thumb thumb-add" onClick={() => input.current.click()} disabled={disabled || busy}>
          <Camera size={22} /><span className="text-[10px] leading-tight">Take photo</span>
        </button>
        <button type="button" data-testid="photo-gallery-button" className="thumb thumb-add" onClick={() => gallery.current.click()} disabled={disabled}>
          <Images size={22} /><span className="text-[10px] leading-tight">Choose from device</span>
        </button>
      </div>
    </div>
  );
};
